// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isUserInResult = objectOf({
  id: string,
  app_group_id: string,
  test_name: string,
  external_id: string,
  email: string,
  internal_user_groups_membership_ids: arrayOf(string),
});

export const isAppSettingsInternalUserGroupsExtractUsersFromIdsResult = objectOf({
  already_in_group: arrayOf(isUserInResult),
  not_in_group: arrayOf(isUserInResult),
  no_user_found: arrayOf(isUserInResult),
  test_user_names_of_users_not_in_upload: arrayOf(string),
});
